import { equals, pathOr, values } from "ramda";
import { selectCategoryBySlug, selectOffice } from "./selectors";
import FuzzySet from "fuzzyset";
import React, { useDispatch, useEffect, useGlobal } from "reactn";
import queryString from "query-string";

export const useOffices = () => {
	const [offices] = useGlobal("offices");
	const loading = Object.values(offices).length === 0;

	return [offices, loading];
};

export const useProcedures = () => {
	const getCategoriesByOrganization = useDispatch(
		"getCategoriesByOrganization"
	);
	const categoryParam = queryString.parse(location.search).category;
	const [categories] = useGlobal("categories");
	const { id: categoryId } =
		selectCategoryBySlug(categories, categoryParam) || {};

	const [procedureByOffices] = useGlobal("procedureByOffices");
	const { procedureList, isLoading } = procedureByOffices;

	useEffect(() => {
		if (categoryId) getCategoriesByOrganization({ categoryId });
	}, [categoryId]);

	return [procedureList, isLoading];
};

export const useOffice = (officeSlug) => {
	const [offices] = useGlobal("officesv2");

	const requestOffice = useDispatch("requestOffice");
	const office = selectOffice(offices, officeSlug);

	useEffect(() => {
		requestOffice({ officeSlug });
	}, [officeSlug, requestOffice]);

	return [office, offices.isLoading, offices.errorMessage];
};

export const useOfficesByCategoryId = () => {
	const requestOfficeByCategory = useDispatch("getOfficesByCategoryId");

	const [procedureByOffices] = useGlobal("procedureByOffices");
	const { offices } = procedureByOffices;

	const handleOnGetOfficesByCategory = (categoryId) => {
		if (categoryId && categoryId > 0)
			requestOfficeByCategory({ categoryId });
	};

	return [offices, handleOnGetOfficesByCategory];
};

const compareStrings = (a, b) => {
	if (!a) return false;
	if (a.toLowerCase().includes(b)) return true;
	const fz = FuzzySet();
	fz.add(b);
	const result = fz.get(a);
	if (result === null) return false;
	return result[0][0] > 0.3;
};

export const useSearch = (categorySlug, districtName, folder, searchQuery) => {
	const [categories] = useGlobal("categories");
	const [offices] = useGlobal("offices");
	const officeList = values(offices);
	const category = selectCategoryBySlug(categories, categorySlug) || {};
	// useProcedures();
	// array of [search query, path, fn]
	const filterFns = [
		[category.id, ["category_id"]],
		[districtName, ["location", "district"]],
		[folder, ["folder"]],
		[searchQuery, ["name"], compareStrings],
	]
		// is a filter fn provided? else use `equals`
		.map((arr) => (arr[2] ? arr : [arr[0], arr[1], equals]))
		// if query is not null
		.filter(([query]) => query)
		// compare office[path] and query using fn
		.map(
			([query, path, fn]) =>
				(office) =>
					fn(pathOr(null, path, office), query)
		);
	// apply all filter functions in sequence
	const filteredOffices = filterFns
		.reduce((arr, fn) => arr.filter(fn), officeList)
		.sort((off0, off1) => {
			// sort online first
			if (!off0.online && off1.online) return 1;
			if (off0.online && !off1.online) return -1;
			// then, sort by distance
			if (off0.distance && off0.distance.distance)
				return off0.distance.distance - off1.distance.distance;
			return 0;
		});
	return [
		filteredOffices,
		officeList.length === 0 || categories.isLoading,
		{},
	];
};

export const useFilteredOffices = useSearch;

//const filter = a => array.filter( a => query

// [].
